export const urls = {
	main: '/',
	admin: '/admin',
	loginSuperAdmin: '/login/super-admin',
	recoveryPassword: '/login/super-admin/recovery-password',
	resetPassword: '/auth/reset-password',
	dashboard: '/admin/dashboard',
	supperAdminOppoList: '/admin/oppotunities',
	supperAdminUserList: '/admin/users',
	supperAdminVolList: '/admin/volunteers',
	supperAdminOrgList: '/admin/organizations',
	supperAdminInvitList: '/admin/invites',
	marketing: '/admin/marketing',
	store: '/admin/store-management',
	inbox: '/admin/inbox',
	live: '/admin/live-screen',
	inboxVolunteer: '/admin/chat',
	notFound: '/not-found',
	greetings: '/greetings',
	simpleCongrat: '/congrat',
	accessDenied: '/access-denied',
	feedViewLink: '/volunteer/feed/view',
};

const ADMIN_ORIGINS = {
	local: 'http://localhost:3000',
	dev: 'https://adminapp-dev.justonechesed.org',
	prod: 'https://adminapp.justonechesed.org',
};

const CLIENT_ORIGINS: Record<string, string> = {
	[ADMIN_ORIGINS.local]: 'http://localhost:3000',
	[ADMIN_ORIGINS.dev]: 'https://app-dev.justonechesed.org',
	[ADMIN_ORIGINS.prod]: 'https://app.justonechesed.org',
};

export const getClientHeatmapUrl = (): string => {
	const origin =
		window.location.origin === ADMIN_ORIGINS.local
			? window.location.origin
			: CLIENT_ORIGINS[process.env.REACT_APP_MAIN_URL || ADMIN_ORIGINS.prod] ||
			  CLIENT_ORIGINS[ADMIN_ORIGINS.prod];

	return `${origin}/joc-heatmap`;
};
